// plugins/redirectPlugin.js
export default {
    install(Vue) {
      Vue.prototype.$redirectToPage = function (userData) {
        if (!userData.isFree) {
          this.$router.push('/upgradePaid');
          console.log("Plugin");
        } else {
          this.$router.push('/Upgrade');
          console.log("Plugin");
        }
      };
    },
  };
  